export default __webpack_public_path__ + "static/media/orange.5dce6fb3.svg";